<template>
  <div
    class="app-main-content"
    style="position:relative;"
  >
    <ae-detail-workspace
      ref="bookingWorkspace"
      :parent-context="context"
      :open-multiple="true"
      @back="backToList"
    />
  </div>
</template>

<script>
import { BookingNewContext } from '@/views/cargo/v0/AirExport/bookingNewContext'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { advancedQuery } from '@/api/AirExport/airExportJob'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import { cache } from '@/utils/cacheManager'
import lodash from 'lodash'
import aeDetailWorkspace from './aeWorkspace'

export default {
  name: 'DestinationBusinessAeDetail',
  components: { aeDetailWorkspace },
  data() {
    return {
      context: BookingNewContext.getInstance(),
      loading: null
    }
  },
  computed: {
    officeId() {
      return this.$store.getters.currentOfficeId
    }
  },
  async created() {
    await this.context.prepareData()
    if (Number(cache.hqConfig.get('UICustomization')) === 1) {
      const branchId = this.$store.getters.currentOfficeId
      await UICustomUtil.loadUICustomPageInfo('/DestinationBusiness/AeDetail', branchId)
    }
  },
  async mounted() {
    const jobNo = this.$route.query.key
    const branchId = this.$route.params.branchId || this.$store.getters.currentOfficeId
    if (!jobNo) {
      this.$message.error(this.$t('Message.JumpFailed'))
      return
    }
    const loading = getLoading4Cxt(this)
    try {
      const params = { branchId, jobNo, pageNum: 1 }
      const res = await advancedQuery(params)
      let rowData = res.data.list || []
      if (rowData.length === 0) {
        this.$message.error(this.$t('Message.NoRecordMeetTheConditions'))
        return
      }
      rowData = lodash.cloneDeep(rowData)
      for (const item of rowData) {
        new AirExportJob(item).fillDefaultValue()
        item.version = 0
      }
      // 从store获取列表页当前页数据，用于左侧业务编号列表展示
      const storeJobs = this.$store.state.destinationBusiness.currentPageJobs || []
      if (storeJobs.length > 0) {
        // 过滤出AE类型的业务数据
        const aeJobs = storeJobs.filter(job => job.lob === 'AE')
        if (aeJobs.length > 0) {
          const mergedData = []
          const apiJobMap = new Map(rowData.map(j => [j.jobNo, j]))
          for (const job of aeJobs) {
            const apiJob = apiJobMap.get(job.jobNo)
            mergedData.push(apiJob || job)
          }
          rowData = lodash.cloneDeep(mergedData)
          for (const item of rowData) {
            new AirExportJob(item).fillDefaultValue()
            item.version = 0
          }
        }
      }
      const selectedRow = rowData.find(p => p.jobNo === jobNo) || rowData[0]
      let action = 'look'
      if (this.$route.params.action) {
        action = this.$route.params.action
        delete this.$route.params.action
      }
      this.$refs.bookingWorkspace.onShow(action, rowData, selectedRow)
    } catch (err) {
      this.$message.error(this.$t('Message.JumpFailed'))
      throw err
    } finally {
      loading.close()
    }
  },
  errorCaptured(err) {
    if (err instanceof ErrorTip) {
      this.$message({ message: err.message, type: err.type })
      return false
    }
    return true
  },
  methods: {
    backToList() {
      const targetPath = this.$route.query.menuType === 'overseaTracking'
        ? '/DestinationBusiness/OverseaTracking'
        : '/DestinationBusiness/EndCommerce'
      this.$store.dispatch('tagsView/delView', this.$route).then(() => {
        this.$router.push({ path: targetPath })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
